/**
 * HTTP layer for the RMA grid's stat cards and its bulk-action (invoice)
 * dispatch.
 *
 * Contains:
 * - fetchRmaStats: bucket counts for the RMA stat cards
 * - postRmaBatch: batch RPC dispatch (invoice, with preflight) for the grid's bulk actions
 */
import apiClient from '@sophocles/http-common';

// Bucket counts for the RMA stat cards. Takes the same filter[...] params as
// the odl-app grid list (incl. filter[search] and dot-suffix date ranges), so
// the cards follow the grid exactly; bucket-selection params are stripped
// server-side.
export const fetchRmaStats = params => apiClient.get('/odl-app/rmas/stats/', { params }).then(res => res.data);

// Batch RPC dispatch: {commands: [{key: 'invoice', params: {id}}], preflight?}.
// Resolves with the flat per-entry result list for 200 (all ok) and 207
// (mixed); a 400 all-failed response also carries that list, so callers fold
// it back in rather than treating it as transport failure.
export const postRmaBatch = body =>
  apiClient
    .post('/odl-app/rmas/batch/', body)
    .then(res => res.data)
    .catch(err => {
      if (Array.isArray(err.response?.data)) return err.response.data;
      throw err;
    });
